<template>
  <div class="Exports">
    <div class="Exports-content">
      <img
        src="@/assets/img/icons/icon-caution.svg"
        alt=""
      >
      <h2>{{ $t('exports_create_export_flow_title') }}</h2>
      <p>{{ $t('exports_create_export_flow_subtitle') }}</p>
      <button
        class="Fuell-Button blue"
        @click="showCreateExportationFlow"
      >{{ $t('exports_create_export_flow_button') }}</button>
    </div>
    <create-exportation-flow-modal
      :open.sync="showCreateExportationFlowFlag"
      v-if="showCreateExportationFlowFlag"
    ></create-exportation-flow-modal>
  </div>
</template>

<script>
const CreateExportationFlowModal = () => import('../../_components/CreateExportationFlowModal.vue')
export default {
  name: 'CreateExportationFlowIndex',
  components: {
    CreateExportationFlowModal
  },
  data () {
    return {
      showCreateExportationFlowFlag: false
    }
  },
  computed: {
    isCallingExports () {
      return this.$store.getters['ExportStore/isCallingExports']
    }
  },
  methods: {
    showCreateExportationFlow () {
      this.showCreateExportationFlowFlag = true
    }
  }

}
</script>
<style lang="scss" scoped>
.Exports {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  .Exports-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 634px;
    height: calc(100vh - calc(var(--headHeight) + 26px));
    text-align: center;

    img {
      width: 84px;
      height: 84px;
      margin-bottom: 46px;
    }

    h2 {
      margin: 0 0 12px 0px;
      font-weight: 500;
      font-size: 32px;
      line-height: 48px;
    }

    p {
      font-size: 15px;
      line-height: 24px;
      color: var(--gray);
      margin: 0 0 32px 0px;
    }

    .Fuell-Button {
      padding: 12px 20px;
      font-weight: 400;
      font-size: 20px;
      line-height: 32px;
      height: auto;
    }
  }
}
</style>
